import { FC, useEffect, useState } from 'react';
import tw, { styled } from 'twin.macro';
const TimerContent = styled.p(({ isHeaderTimer }) => [
  tw`font-bold`,
  isHeaderTimer
    ? tw`text-[19px] leading-[23px] text-[#111111] mb-[2px]`
    : tw`text-2xl leading-[29px] mb-2 md:mb-0  text-[#111111] md:text-[32px] md:leading-[39px] md:text-black`,
]);
const TextContent = styled.p(({ isHeaderTimer }) => [
  tw`text-center`,
  isHeaderTimer
    ? tw`text-xs leading-[15x] text-[#666666] font-regular `
    : tw`text-sm leading-[17px] text-[#999999] font-medium md:text-[#666666]`,
]);

const Timer: React.FC<any> = ({ deadline, isHeaderTimer }) => {
  const [days, setDays] = useState(0);
  const [hours, setHours] = useState(0);
  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(0);
  const [time, setTime] = useState(deadline);

  const getTime = () => {
    const time = deadline - Date.now();
    setTime(time);
    if (time > 0) {
      setDays(Math.floor(time / (1000 * 60 * 60 * 24)));
      setHours(Math.floor((time / (1000 * 60 * 60)) % 24));
      setMinutes(Math.floor((time / 1000 / 60) % 60));
      setSeconds(Math.floor((time / 1000) % 60));
    }
  };

  useEffect(() => {
    const interval = setInterval(() => getTime(), 1000);
    return () => clearInterval(interval);
  }, [time]);
  return (
    <>
      {time > 0 && (
        <>
          <div className={`text-center ${isHeaderTimer?"mr-6":"md:mr-8 mr-6"}`}>
            <TimerContent isHeaderTimer={isHeaderTimer} id="day">
              {days < 10 ? '0' + days : days}
            </TimerContent>
            <TextContent isHeaderTimer={isHeaderTimer} className={`text ${isHeaderTimer?"w-[29px]":"md:w-[38px] w-[34px]"}`} >
              {days == 1 ? 'Day' : 'Days'}
            </TextContent>
          </div>
          <div className={`text-center ${isHeaderTimer?"mr-[5px]":"md:mr-[11px] mr-3"}`}>
            <TimerContent isHeaderTimer={isHeaderTimer} id="hour">
              {hours < 10 ? '0' + hours : hours}
            </TimerContent>
            <TextContent isHeaderTimer={isHeaderTimer} className={`text ${isHeaderTimer?"w-[34px]":"w-[41px]"}`}>
              {hours == 1 ? 'Hour' : 'Hours'}
            </TextContent>
          </div>
          <span className={`text ${isHeaderTimer?"h-3 w-1 relative mt-[5px] before:absolute after:absolute before:h-1 after:h-1 before:bg-[#111111] after:bg-[#111111] before:top-0 after:bottom-0 before:left-0 after:left-0 before:w-full after:w-full ":"h-4 w-[5px] relative mt-[11px] before:absolute after:absolute before:h-[5px] after:h-[5px] before:bg-black after:bg-black before:top-0 after:bottom-0 before:left-0 after:left-0 before:w-full after:w-full"}`}></span>
          <div className={`text-center ${isHeaderTimer?"mx-[5px]":"md:mx-[11px] mx-3"}`}>
            <TimerContent isHeaderTimer={isHeaderTimer} id="minute">
              {minutes < 10 ? '0' + minutes : minutes}
            </TimerContent>
            <TextContent isHeaderTimer={isHeaderTimer} className={`text ${isHeaderTimer?"w-[46px]":"w-[54px]"}`}>
              {minutes == 1 ? 'Minute' : 'Minutes'}
            </TextContent>
          </div>
          <span className={`text ${isHeaderTimer?"h-3 w-1 relative mt-[5px] before:absolute after:absolute before:h-1 after:h-1 before:bg-[#111111] after:bg-[#111111] before:top-0 after:bottom-0 before:left-0 after:left-0 before:w-full after:w-full ":"h-4 w-[5px] relative mt-[11px] before:absolute after:absolute before:h-[5px] after:h-[5px] before:bg-black after:bg-black before:top-0 after:bottom-0 before:left-0 after:left-0 before:w-full after:w-full"}`}></span>
          <div className={`text-center ${isHeaderTimer?"ml-[5px]":"md:ml-[11px] ml-3"}`}>
            <TimerContent isHeaderTimer={isHeaderTimer} id="second">
              {seconds < 10 ? '0' + seconds : seconds}
            </TimerContent>
            <TextContent isHeaderTimer={isHeaderTimer} className={`text ${isHeaderTimer?"w-[50px]":"w-[59px]"}`}>
              {seconds == 1 ? 'Second' : 'Seconds'}
            </TextContent>
          </div>
        </>
      )}
    </>
  );
};

export default Timer;
